import { styled, Theme } from '@mui/material';

export const HeaderThemedStyle = styled('h1')(
  ({ theme }: { theme: Theme }) => ({
    fontSize: '33px',
    fontWeight: 400,
    scrollMarginTop: '154px',
    '&::after': {
      backgroundColor: `${theme.palette.secondary.main} !important`,
    },
    '@media (min-width:744px)': {},
  })
);
